








import { Component, Prop, Vue } from "vue-property-decorator";

@Component({
  components: {
  },
})
export default class StSupBadge extends Vue {
  @Prop({default: 'text-white bg-gray-500'}) bgClass!: string;
}
